<template>
  <mdb-container>
    <div class="text-left" v-if="currentGroup && details">
      <banner-small :group="currentGroup" title="Reputation"/>
      <form v-on:submit.prevent="saveChanges" id="input-form">
        <mdb-btn @click="showAbout=true" tag="a"
                 type=""
                 icon="question" rounded size="sm" v-if="!showAbout">What is this?
        </mdb-btn>
        <mdb-card class="mb-4" v-if="showAbout">
          <mdb-card-header class="primary-color text-white">
            <h5>About Reputation</h5>
          </mdb-card-header>
          <mdb-card-body>
            <p>The reputation feature lets you award points to your members for participating and to get points removed
              for
              no shows or late cancellations. This can be a fun way to promote participation as well as to identify
              members who might not be worthy of membership according to your rules.
            </p>
            <p>You can name it whatever you like. Street Cred, Participation Score,
              Group Points... whatever makes sense to your group.
            </p>
            <mdb-btn @click="showAbout=false" tag="a"
                     type=""
                     icon="times-circle" rounded size="sm">Ok, Got It</mdb-btn>
          </mdb-card-body>
        </mdb-card>
        <mdb-card class="mb-4">
          <mdb-card-header class="primary-color text-white">
            <h5>Rules</h5>
          </mdb-card-header>
          <mdb-card-body>
            <input aria-label="Feature Enabled" class="form-control form-check-input" id="rep-enabled" type="checkbox"
                   v-model="details.reputationEnabled"/>
            <label for="rep-enabled">Feature Enabled </label>
            <div v-if="details.reputationEnabled">
              <mdb-input label="Label" placeholder="What do you want to call it?" v-model="details.reputationLabel" required/>
            </div>
          </mdb-card-body>
        </mdb-card>
        <mdb-card class="mb-4" v-if="details.reputationEnabled">
          <mdb-card-header class="primary-color text-white">
            <h5>Earning Points</h5>
          </mdb-card-header>
          <mdb-card-body>
            <mdb-input label="Attending an Event" :step="1" type="number" required v-model="details.attendanceScore"/>
            <mdb-input label="Hosting an Event" :step="1" type="number" required v-model="details.hostingScore"/>
            <mdb-input label="No Show" :step="1" type="number" required v-model="details.noShowScore"/>
            <div class="text-warning" v-if="details.noShowScore>0">Most groups make this a negative number.</div>
            <mdb-input label="Late Cancel" required :step="1" type="number" v-model="details.lateCancelScore"/>
            <div class="text-warning" v-if="details.lateCancelScore>0">Most groups make this a negative number.</div>
          </mdb-card-body>
        </mdb-card>
        <mdb-card class="mb-4" v-if="details.reputationEnabled">
          <mdb-card-header class="primary-color text-white">
            <h5>Achievements</h5>
          </mdb-card-header>
          <mdb-card-body>
            <avatar :avatar="settings.staticImageUrl + '/demo_avatar1.jpg'"
                    badge="Negative Score"
                    badge-color="danger"
                    container-class="avatar-right"
                    name="Example Negative"
                    reputation="red"
                    v-if="details.showNegative"/>

            <input aria-label="Show negative scores" class="form-control form-check-input" id="show-negative"
                   type="checkbox"
                   v-model="details.showNegative"/>
            <label for="show-negative">Show negative scores.</label>
            <div><small>Some groups like to show negative scores as incentive not to no show. Others think it's mean.
              Your call.</small></div>
            <hr>
            <div>
              <h5 class="text-secondary">Members will get a colored band around their avatar when these milestone scores
                are met:</h5>
            </div>
            <div>
              <avatar :avatar="settings.staticImageUrl + '/demo_avatar2.jpg'"
                      badge="Green Score"
                      badge-color="info"
                      name="Example Green Achievement"
                      reputation="green"/>
              <mdb-input placeholder="Score to achieve the green band." :step="1" type="number"
                         required
                         v-model="details.greenLevel"/>
            </div>
            <div>
              <avatar :avatar="settings.staticImageUrl + '/demo_avatar3.jpg'"
                      badge="Bronze Score"
                      badge-color="info"
                      name="Example Bronze Achievement"
                      reputation="bronze"/>

              <mdb-input placeholder="Score to achieve the bronze band." :step="1" type="number"
                         required
                         v-model="details.bronzeLevel"/>
            </div>
            <div>
              <avatar :avatar="settings.staticImageUrl + '/demo_avatar4.jpg'"
                      badge="Silver Score"
                      badge-color="info"
                      name="Example Silver Achievement"
                      reputation="silver"/>

              <mdb-input placeholder="Score to achieve the silver band." :step="1" type="number"
                         required
                         v-model="details.silverLevel"/>

            </div>
            <div>
              <avatar :avatar="settings.staticImageUrl + '/demo_avatar5.jpg'"
                      badge="Gold Score"
                      badge-color="info"
                      name="Example Gold Achievement"
                      reputation="gold"/>
              <mdb-input placeholder="Score to achieve the gold band." :step="1" type="number"
                         required
                         v-model="details.goldLevel"/>
            </div>
          </mdb-card-body>
        </mdb-card>
        <mdb-card>
          <mdb-card-body>
             <mdb-btn type="submit" icon="save">Save</mdb-btn>
          </mdb-card-body>
        </mdb-card>
      </form>
    </div>
  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import {mapState} from 'vuex'
import bannerSmall from '../group/BannerSmall'
import Avatar from "../common/Avatar";

import {mdbBtn, mdbCard, mdbCardBody, mdbCardHeader, mdbContainer, mdbInput} from 'mdbvue';

export default {
    name: "group-reputation",
    order: 1,
    components: {
      mdbContainer,
      mdbInput,
      mdbBtn,
      bannerSmall,
      mdbCard,
      mdbCardBody,
      mdbCardHeader,
      Avatar
    },
    computed: mapState({
                         currentGroup: state => state.currentGroup,
                         settings: state => state.settings
                       }),
    data() {
      return {
        details: null,
        showAbout: false
      }
    },
    mounted() {
      document.title = "Reputation"
      if (!this.currentGroup) {
        api.groupBasics(this.$route.params.id, "public");
      }
      this.$store.dispatch("setExecuting", true)
      api.get("/group/reputation/" + this.$route.params.id).then(
        (results) => {
          this.details = results.data
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    methods: {
      saveChanges() {
        this.$store.dispatch("setExecuting", true)
        api.post("/group/reputation/" + this.$route.params.id,this.details).then(
          (results) => {
            this.$notify.success({message:"Saved",timeOut: 2000})
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      }

    }
  };

</script>
